import React from "react";
import { Reveal } from "./Reveal";
import { FEATURES } from "../../data/content";

const ScreenFrame = ({ image, alt }) => (
  <div className="border border-white/10 bg-[#0A0A0A]">
    <div className="flex items-center gap-1.5 px-3 h-8 border-b border-white/10 bg-black/40">
      <span className="h-2 w-2 rounded-full bg-white/15" />
      <span className="h-2 w-2 rounded-full bg-white/15" />
      <span className="h-2 w-2 rounded-full bg-white/15" />
    </div>
    <img src={image} alt={alt} className="w-full block" loading="lazy" />
  </div>
);

const Features = () => {
  return (
    <section id="features" data-testid="features-section" className="py-24 md:py-32 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-16 md:mb-24">
          <Reveal>
            <p className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-5">
              / Inside the terminal
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white">
              See what you're working with.
            </h2>
          </Reveal>
        </div>

        <div className="flex flex-col gap-20 md:gap-32">
          {FEATURES.map((f, i) => {
            const reversed = i % 2 === 1;
            return (
              <div
                key={f.title}
                data-testid={`feature-block-${i + 1}`}
                className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center"
              >
                <Reveal
                  className={`lg:col-span-7 ${reversed ? "lg:order-2" : ""}`}
                  delay={0.05}
                >
                  <ScreenFrame image={f.image} alt={f.title} />
                </Reveal>
                <Reveal
                  className={`lg:col-span-5 ${reversed ? "lg:order-1" : ""}`}
                  delay={0.12}
                >
                  <p className="font-mono text-xs uppercase tracking-[0.18em] text-zinc-500 mb-4">
                    {f.eyebrow}
                  </p>
                  <h3 className="font-display text-2xl sm:text-3xl font-medium tracking-tight text-white">
                    {f.title}
                  </h3>
                  <p className="mt-4 text-lg text-zinc-400 leading-relaxed">
                    {f.desc}
                  </p>
                </Reveal>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
